import React from 'react';
import PropTypes from 'prop-types';
import { Menu, Button, Popover } from 'antd';

import { enquireScreen } from 'enquire-js';
import websiteLogo from '../assets/imgs/website-logo.png';



class Header extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    isMobile: PropTypes.bool,
    activefaq: PropTypes.bool,
    activeProduct: PropTypes.bool,
    activeHome: PropTypes.bool,
    handleclick: PropTypes.func,
  }

  state = {
    menuVisible: false,
    menuMode: 'horizontal',
  };

  componentDidMount() {
    enquireScreen((b) => {
      this.setState({ menuMode: b ? 'inline' : 'horizontal' });
    });
  }

  handleShowMenu = () => {
    this.setState({ menuVisible: !this.state.menuVisible});
  }

  handleMenuClick = (event) => {
    this.props.handleclick(event.key);
    this.setState({ menuVisible: false});
  }

  render() {
    const { activefaq, activeProduct, activeHome, handleclick } = this.props;
    const { menuMode, menuVisible } = this.state;

    const menu = (
      <Menu mode="inline" id="nav" key="nav" onClick={(e) => this.handleMenuClick(e)}>
        <Menu.Item key="home" >
          <span>Home</span>
        </Menu.Item>
        <Menu.Item key="product">
          <span>Product</span>
        </Menu.Item>
        <Menu.Item key="FAQ">
          <span>FAQ</span>
        </Menu.Item>
      </Menu>
    );

    return (
    <header {...this.props}>
      <div className="headerWrapper">
        <img src={websiteLogo} className="logo" alt='logo'/>
        {
          menuMode === 'horizontal' ? (
          <div>
            <div className={activefaq ? 'active-btn' : 'button'} onClick={() => handleclick('FAQ')}>
              <Button>FAQ</Button>
            </div>
            <div className={activeProduct ? 'active-btn' : 'button'} onClick={() => handleclick('product')}>
              <Button>Product</Button>
            </div>
            <div className={activeHome ? 'active-btn' : 'button'} onClick={() => handleclick('home')}>
              <Button>Home</Button>
            </div>
          </div>) : (
          <Popover
            overlayClassName="popover-menu"
            placement="bottomRight"
            content={menu}
            trigger="click"
            visible={menuVisible}
            arrowPointAtCenter
            onVisibleChange={this.handleShowMenu}
          >
            <svg className="nav-phone-menu" onClick={this.handleShowMenu}>
              <use xlinkHref="#iconmenu1" />
            </svg>
          </Popover>)
        }
      </div>
    </header>
    );
  }
}

export default Header;
